module.exports = __webpack_public_path__ + "img/collection-weddingRingsWomen@2x.403353e.webp";